import React, { useEffect } from 'react'
import Popup from '../common/Popup'
import { checkMoney, checkWalletsType } from '../../utils/configData'
import { fetchGetInvoice } from '../../pages/FetchTransactions';
import { useTranslation } from 'react-i18next';

export const ViewDetails = ({ chatData, setIsPopupOpenView, isPopupOpenView, invoice, handleConfirm, status, userType, buyWalletData, interlocutorFName, interlocutorLName }) => {
    const currencySellData = checkMoney(chatData.sell_currency);
    const currencyBuyData = checkMoney(chatData.buy_currency);
    const isCoin = checkMoney(chatData.sell_currency).isCoin;

    const convertTRCIdentifiers = (input) => {
        return input.replace(/trc(\d+)/gi, (match, number) => `(TRC-${number})`);
    }


    const { t } = useTranslation();
    const confirmPopup = () => {
        closePopupView();
        handleConfirm();
    }
    const downloadInvoice = async (id) => {
        fetchGetInvoice(id).then((data) => {
            if (data) {
                window.open(data.url, "_blank");
            }
        });
    };

    const closePopupView = () => {
        setIsPopupOpenView(false);
    };

    useEffect(() => {
        if (invoice) {
            setIsPopupOpenView(true);
        }
    }, [invoice, setIsPopupOpenView]);

    function copyToClipboard(input, event) {
        // Перевіряємо, чи підтримує браузер Clipboard API
        if (!navigator.clipboard) {
            console.error('Clipboard API не підтримується у вашому браузері.');
            // Змінюємо клас елемента на помилковий
            if (event && event.target) {
                event.target.className = 'disabled';
            }
            return;
        }

        // Перетворюємо вхідні дані на рядок, якщо вони не є рядком
        const textToCopy = typeof input === 'string' ? input : input.toString();

        // Використовуємо API для запису в буфер обміну
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
                console.log('Текст успішно скопійований в буфер обміну.');
                // Змінюємо клас елемента на успішний
                if (event && event.target) {
                    event.target.className = 'ri-check-line';
                    setTimeout(() => {
                        event.target.className = 'ri-clipboard-line';
                    }, 700);
                }
            })
            .catch(err => {
                console.error('Сталася помилка при копіюванні в буфер обміну:', err);
                // Змінюємо клас елемента на помилковий
                if (event && event.target) {
                    event.target.className = 'ri-close-line';
                    setTimeout(() => {
                        event.target.className = 'ri-clipboard-line';
                    }, 700);
                }
            });
    }


    const clientView = (checkWalletsType(chatData.sell_currency) === "crypto" ? (
        <div className="view-details">
            <button onClick={closePopupView} className="close-popup">
                <i className="ri-close-line"></i>
            </button>
            <h3>{t("Proceed with the Payment")}</h3>
            <div className="wrapper-list">
                {/* <div className="wrapper-list__item">
                    <h4>{t("Crypto Wallet")}</h4>
                    <p>{chatData.details[0].crypto.code}  <i onClick={(event) => copyToClipboard(chatData.details[0].crypto.code, event)} className="ri-clipboard-line"></i></p>
                </div> */}



                {Object.entries(chatData.details[0].crypto).map(([key, value], index, array) => {
                    if (key === "index") return null;

                    const formatted = (key) => {
                        if (!key) return "";
                        return key
                            .split('_')
                            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                            .join(' ');
                    }


                    const formattedValue = key === "payment_method" ? convertTRCIdentifiers(value.toUpperCase()) : value;

                    const formattedKey = key === "network" || key === "payment_method" ? formatted(key) : key;

                    const isCopy = key === "network" || key === "payment_method" ? false : true;

                    return (
                        <React.Fragment key={key}>
                            <div className="wrapper-list__item">
                                <h4>{formattedKey}</h4>
                                <p>
                                    {formattedValue}
                                    {isCopy ?
                                        <i onClick={(event) => copyToClipboard(formattedValue, event)} className="ri-clipboard-line"></i> : null
                                    }
                                </p>
                            </div>

                            <div className="line-p"></div>
                        </React.Fragment>
                    );
                })}


                <div className="wrapper-list__item">

                    <h4>{t("Give (including fee)")}</h4>
                    <p>
                        <img src={currencySellData.img} alt="" />
                        <p>{parseFloat(chatData.sell_amount) + parseFloat(chatData.fee)}</p>
                        <i onClick={(event) => copyToClipboard(chatData.buy, event)} className="ri-clipboard-line"></i>
                    </p>
                </div>




            </div>


            {/* <div className="invoice-section">
                <h4>{t("Proforma Invoice")}</h4>
                <button
                    className="link-invoice"
                    onClick={() => downloadInvoice(chatData.id)}
                >
                    <p>{t("invoice.pdf")}</p> <i className="ri-download-2-line"></i>
                </button>
            </div> */}




            <div className="wrapper-buttons">
                <button onClick={closePopupView} className="white-button">
                    {t("Back")}
                </button>
                <button style={status > 1 ? { display: "none" } : {}} onClick={() => confirmPopup()} className="green-button">
                    {t("Confirm Payment")}
                </button>
            </div>
        </div>
    ) : (
        <div className="view-details">
            <button onClick={closePopupView} className="close-popup">
                <i className="ri-close-line"></i>
            </button>
            <h3>{t("Proceed with the Payment")}</h3>
            <div className="wrapper-list">

                {Object.entries(chatData.details[1].bank).map(([key, value], index, array) => {
                    if (key === "index" || key === "superfaktura") return null;

                    const formatted = (key) => {
                        if (!key) return "";
                        return key
                            .split('_')
                            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                            .join(' ');
                    }


                    const formattedValue = key === "network" || key === "payment_method" ? value.toUpperCase() : value;

                    const formattedKey = key === "network" || key === "payment_method" ? formatted(key) : key;

                    const isCopy = key === "network" || key === "payment_method" ? false : true;

                    return (
                        <React.Fragment key={key}>
                            <div className="wrapper-list__item">
                                <h4>{formattedKey}</h4>
                                <p>
                                    {formattedValue}
                                    {isCopy ?
                                        <i onClick={(event) => copyToClipboard(formattedValue, event)} className="ri-clipboard-line"></i> : null
                                    }
                                </p>
                            </div>

                            <div className="line-p"></div>
                        </React.Fragment>
                    );
                })}





                <div className="wrapper-list__item">

                    <h4>{t("Give (including fee)")}</h4>
                    <p>
                        <img src={currencySellData.img} alt="" />
                        <p>{parseFloat(chatData.sell_amount) + parseFloat(chatData.fee)}</p>
                        <i onClick={(event) => copyToClipboard(chatData.buy, event)} className="ri-clipboard-line"></i>
                    </p>
                </div>



                <div className="line-p"></div>



                <div className="wrapper-list__item">
                    <h4>{t("Purpose of payment")}</h4>
                    <p>
                        {`Throwing according to the invoice #${chatData.name.toUpperCase().slice(2).split("-").join("")}`}
                        <i onClick={(event) => copyToClipboard(`Throwing according to the invoice #${chatData.name.toUpperCase().slice(2).split("-").join("")}`, event)} className="ri-clipboard-line"></i>
                    </p>
                </div>
            </div>
            <div className="invoice-section">
                <h4>Proforma Invoice</h4>
                <button
                    className="link-invoice"
                    onClick={() => downloadInvoice(chatData.id)}
                >
                    <p>{t("invoice.pdf")}</p> <i className="ri-download-2-line"></i>
                </button>
            </div>
            <div className="wrapper-buttons">
                <button onClick={closePopupView} className="white-button">
                    {t("Back")}
                </button>
                <button style={status > 1 ? { display: "none" } : {}} onClick={() => confirmPopup()} className="green-button">
                    {t("Confirm Payment")}
                </button>
            </div>
        </div>
    ));

    const managerView = (checkWalletsType(chatData.sell_currency) === "bank" ? (
        <div className="view-details">
            <button onClick={closePopupView} className="close-popup">
                <i className="ri-close-line"></i>
            </button>
            <h3>{t("Proceed with the Payment")}</h3>
            <div className="wrapper-list">
                <div className="wrapper-list__item">
                    <h4>{t("Crypto Wallet")}</h4>
                    <p>{buyWalletData.num}<i onClick={(event) => copyToClipboard(buyWalletData.num, event)} className="ri-clipboard-line"></i></p>
                </div>
                <div className="line-p"></div>
                <div className="wrapper-list__item">
                    <h4>{t("Network")}</h4>
                    <p>{convertTRCIdentifiers(buyWalletData.type.toUpperCase())}<i onClick={(event) => copyToClipboard(convertTRCIdentifiers(buyWalletData.type.toUpperCase()), event)} className="ri-clipboard-line"></i></p>
                </div>
                <div className="line-p"></div>

                <div className="wrapper-list__item">
                    <h4>{t("Amount to be sent")}</h4>
                    <p><img src={currencyBuyData.img} alt="" />{chatData.buy_amount}  <i onClick={(event) => copyToClipboard(chatData.sell_amount, event)} className="ri-clipboard-line"></i></p>

                </div>
            </div>




            <div className="wrapper-buttons">
                <button onClick={closePopupView} className="white-button">
                    {t("Back")}
                </button>
            </div>
        </div>
    ) : (
        <div className="view-details">
            <button onClick={closePopupView} className="close-popup">
                <i className="ri-close-line"></i>
            </button>
            <h3>{t("Proceed with the Payment")}</h3>
            <div className="wrapper-list">
                <div className="wrapper-list__item">
                    <h4>{t("IBAN")}</h4>
                    <p>{buyWalletData.iban}<i onClick={(event) => copyToClipboard(buyWalletData.iban, event)} className="ri-clipboard-line"></i></p>
                </div>
                <div className="line-p"></div>
                <div className="wrapper-list__item">
                    <h4>{t("SWIFT/BIC Code")}</h4>
                    <p>{buyWalletData.code}<i onClick={(event) => copyToClipboard(buyWalletData.code, event)} className="ri-clipboard-line"></i></p>
                </div>
                <div className="line-p"></div>
                <div className="wrapper-list__item">
                    <h4>{t("Receiver")}</h4>
                    <p>{interlocutorFName + " " +  interlocutorLName}<i onClick={(event) => copyToClipboard(interlocutorFName + " " +  interlocutorLName, event)} className="ri-clipboard-line"></i></p>
                </div>
                <div className="line-p"></div>
                <div className="wrapper-list__item">
                    <h4>{t("Amount to be sent")}</h4>

                    <p><img src={currencyBuyData.img} alt="" />{chatData.buy_amount}<i onClick={(event) => copyToClipboard(chatData.sell_amount, event)} className="ri-clipboard-line"></i></p>

                </div>
            </div>

            <div className="wrapper-buttons">
                <button onClick={closePopupView} className="white-button">
                    {t("Back")}
                </button>
            </div>
        </div>
    ));

    return (

        <Popup isOpen={isPopupOpenView} onClose={closePopupView}>
            {userType === 0 ? clientView : managerView}
        </Popup>
    )
}
